export default __webpack_public_path__ + "static/media/E22_LOGO_EC_CULTURE_RGB_V.c4cedf3e.png";